export const companyName = process.env.REACT_APP_COMPANY_NAME || "Dicio";
export const sandboxLabel = `Sandbox ${companyName}`;
export const documentTitle = "Sandbox";
